import { actionGenerator, IReduxAction } from '../../utils/actions';
import { IExperiments } from '../../types/reducers/experiments';

export const APPEND_EXPERIMENT = 'EXPERIMENTS :: APPEND_EXPERIMENT';

export type TAppendExperimentPresetAction = IReduxAction<typeof APPEND_EXPERIMENT, IExperiments>;

export const appendExperiment = actionGenerator<typeof APPEND_EXPERIMENT, IExperiments>(APPEND_EXPERIMENT);
